<header>
  <div class="d-flex">
    <h3 class="dialog-title">
      <fa-icon [icon]="['fas', 'wrench']" ></fa-icon>&nbsp;
      <span>{{ headerLabel }}</span>
    </h3>
    <div class="ml-auto d-flex">
      <ul class="list-inline pull-right">
        <li class="list-inline-item">
          <fieldmagic-primary-button
            (click)="onSubmit()"
            icon="plus"
            label="add"
          ></fieldmagic-primary-button>
        </li>
        <li class="list-inline-item">
          <fieldmagic-primary-button
            variant="error"
            (click)="onCancelDialog()"
            icon="times"
            label="close"
          ></fieldmagic-primary-button>
        </li>
      </ul>
    </div>
  </div>
</header>
<hr class="separator"/>
<mat-dialog-content>
  <ng-container *ngIf="bLoaded; else loading">
    <ng-container *ngIf="arInspectionChecklist.length; else noInspectionChecklist">
      <fieldmagic-number-input
        label="{{ 'quantity' | translate }}"
        [(ngModel)]="intAssetQauantity"
      >
      </fieldmagic-number-input>
      <table class="table">
        <thead>
            <tr>
              <td>
                <input
                  type="checkbox"
                  class="cursor-pointer"
                  [(ngModel)]="selectAllChecklist"
                  (change)="onChangeCheckbox($event, {}, true)"
                />
              </td>
              <td>
                {{ 'service_group' | translate }}
              </td>
              <td>
                {{ 'annual_price' | translate }}
              </td>
            </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let inspectionChecklist of arInspectionChecklist; index as index">
            <tr>
              <td>
                <input
                  type="checkbox"
                  class="cursor-pointer"
                  [checked]="inspectionChecklist.is_checked"
                  (change)="onChangeCheckbox($event, inspectionChecklist)"
                />
              </td>
              <td>
                {{ inspectionChecklist.prompt_name }}
              </td>
              <td>
                {{ inspectionChecklist.unit_price | currency }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
</mat-dialog-content>
<ng-template #loading>
  <div class="col-md-12 text-center pt-3">
    <fa-icon [icon]="['fas','spinner']" [spin]="true" aria-hidden="true" class="pr-1 h4"></fa-icon>
  </div>
</ng-template>
<ng-template #noInspectionChecklist>
  <div class="col-md-12 text-center pt-3">
    {{ 'asset_type_has_no_active_checklist' | translate }}
  </div>
</ng-template>